import { Flex } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { BackButton } from "../elements/BackButton";

export function DetailPageHeader({ children }: PropsWithChildren) {
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      mb={4}
      width="100%"
    >
      <BackButton />
      <Flex>{children}</Flex>
    </Flex>
  );
}
